import React from 'react';
import './match-answers.css';

// "Neden %87 eşleşme?" (Kaan, 5 Kasım 2026, seçenek B): every campaign question with its answer word and one sentence
// saying why. A locked event shows the answers but not the sentences (they could name the event).
export const answerWord = v => v == null ? 'Bilinmiyor' : v >= 0.65 ? 'Güçlü' : v >= 0.4 ? 'Kısmen' : 'Zayıf';
const tone = v => v == null ? 'unknown' : v >= 0.65 ? 'strong' : v >= 0.4 ? 'partial' : 'weak';
export function MatchAnswers({ questions = [], answers = {}, reasons = null, locked = false }) {
  return <ul className="bs-match-answers">
    {questions.map(q => { const v = answers?.[q.id]; const why = locked ? null : reasons?.[q.id];
      return <li key={q.id} className="bs-match-answer">
        <span className="bs-match-question">{q.text}{q.weight === 'high' && <span className="bs-match-weight"> · Çok önemli</span>}</span>
        <span className="bs-match-word" data-tone={tone(v)}>{answerWord(v)}</span>
        {why && <span className="bs-match-why">{why}</span>}
      </li>; })}
  </ul>;
}
